/**
 * A write that refuses to fail quietly.
 *
 * `fetch` only rejects on a network failure. A 400, 403 or 500 resolves like
 * any other response, so `await fetch(...)` with no follow-up reports success
 * for a request the server threw away. That is how an apparatus check could close as
 * a completed inspection with nothing recorded against it, and how a refused
 * delete could remove someone from an incident report while their hours stayed
 * on the books.
 *
 * Throws on a non-2xx status or a `{ success: false }` body, carrying the
 * server's own message where there is one. The caller still has to surface it --
 * this only guarantees there is something to surface.
 */
export async function sendRequest(url, options) {
  const res = await fetch(url, options)

  let body = null
  try {
    body = await res.json()
  } catch {
    // Not every endpoint answers with JSON; status alone decides those.
  }

  if (!res.ok || (body && body.success === false)) {
    const err = new Error(body?.error || `Request failed (${res.status})`)
    err.status = res.status
    err.body = body
    throw err
  }

  return body
}
